/* global  */ // tUrl等のグローバル変数を宣言する
/* global  AjaxZip3 */
import Swiper from 'swiper' // Swiper
// import PerfectScrollbar from 'perfect-scrollbar' // 独自スクロールバー
// position:styckyのポリフィル
// Stickyfill.add(document.querySelectorAll('.sticky'))

jQuery(function($) {
  $('.js-acc').on('click', function() {
    $(this).toggleClass('active')
    $(this)
      .next()
      .toggleClass('active')
  })
  /*
        ######  ##      ## #### ########  ######## ########
       ##    ## ##  ##  ##  ##  ##     ## ##       ##     ##
       ##       ##  ##  ##  ##  ##     ## ##       ##     ##
        ######  ##  ##  ##  ##  ########  ######   ########
             ## ##  ##  ##  ##  ##        ##       ##   ##
       ##    ## ##  ##  ##  ##  ##        ##       ##    ##
        ######   ###  ###  #### ##        ######## ##     ##
*/
  if ($('#case_slide')[0]) {
    // Swiperコンテナを検出したら実行
    // eslint-disable-next-line no-unused-vars
    const caseSwiper = new Swiper('#case_slide', {
      effect: 'slide',
      loop: true,
      autoplay: {
        delay: 1000
      },
      speed: 5000,
      spaceBetween: 20,
      slidesPerView: 'auto',
      centeredSlides: true,
      // navigation: {
      //   nextEl: '.swiper-button-next',
      //   prevEl: '.swiper-button-prev'
      // },
      // pagination: {
      //   el: '.swiper-pagination',
      //   type: 'bullets'
      // },
      breakpoints: {
        769: {}
      }
    })
  }

  /*
 ######## ########  ##     ## ##    ## ##    ##  #######
    ##    ##     ## ##     ## ###   ## ##   ##  ##     ##
    ##    ##     ## ##     ## ####  ## ##  ##   ##     ##
    ##    ########  ##     ## ## ## ## #####     #######
    ##    ##   ##   ##     ## ##  #### ##  ##   ##     ##
    ##    ##    ##  ##     ## ##   ### ##   ##  ##     ##
    ##    ##     ##  #######  ##    ## ##    ##  #######
*/
  function trunk8() {
    $('.js-t8.line2').trunk8({
      // 指定要素に行数制限をかける
      lines: 2,
      fill: '...'
    })
  }
  if ($('.js-t8')[0]) {
    // 要素を検出したら実行
    trunk8()
    $(window).on('load resize ', function() {
      trunk8()
    })
  }

  /*
  ##       ######  #######  #####  ######
  ##      ##    ##    ###  ##   ## ##   ##
  ##      ##    ##   ###   ####### ##   ##
  ##      ##    ##  ###    ##   ## ##   ##
  #######  ######  ####### ##   ## ######
  */
  /* global lozad */
  lozad('.lozad', {
    rootMargin: '3%',
    loaded: function(el) {
      el.classList.add('active') // 画面に交差した要素をactive
    }
  }).observe()
})
